// extracted by css-extract-rspack-plugin
export default {"tooltipText":"tooltip-text--TmIdLuqIXXIkhJ6k"};